import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { IActiveDirectoryUserResponse } from 'src/models/api-response/add-user-response.interface';
import { IGroup } from 'src/models/user/group.interface';
import { UserService } from 'src/services/user.service';
import { UtilService } from 'src/services/util.service';
import { INewUser } from 'src/models/user/new-user.interface';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-add-user',
    templateUrl: './add-user.component.html',
    styleUrls: ['./add-user.component.css'],
    standalone: false
})
export class AddUserComponent implements OnInit {

  userSearchFormControl = new FormControl('', [Validators.required],);
  newUserInfoFormGroup = new FormGroup({
    jobtitle: new FormControl('', [Validators.required]),
    divisionid: new FormControl('',[Validators.required]),
    sectionid: new FormControl('', [Validators.required]),
    admin:  new FormControl(false),
    supervisor:new FormControl(false)
  })
  activeDirectoryUserList: Array<IActiveDirectoryUserResponse>;
  selectedUser: IActiveDirectoryUserResponse;
  userHasBeenSelected: boolean;
  userAlreadyExist: boolean;
  userDivisions: IGroup[];
  userSections: IGroup[];
  userAddedSuccessfully: boolean;
  loading: boolean;


  constructor(private dialogRef: MatDialogRef<AddUserComponent>,
              private userService: UserService,
              private utilService: UtilService,
              private router: Router,
              private snackBar: MatSnackBar) {
    this.activeDirectoryUserList = [];
    this.userDivisions = [];
    this.userSections = [];
    this.selectedUser  = {
      DisplayName: '',
      FirstName: '',
      LastName: '',
      Email: '',
      LoginName: '',
      IsInAviationDirectory: false,
      AviationDirectoryUserID: 0};
    this.userHasBeenSelected = false;
    this.userAlreadyExist = false;
    this.userAddedSuccessfully = false;
    this.loading = false;

  }

  ngOnInit(): void {
  }

  onUserSearch(): void{
    if(!this.userSearchFormControl.valid){
      return;
    }
    this.loading = true;
    let searchBy = 'name';
    if(this.userSearchFormControl.value!.includes('@phoenix.gov')){
      searchBy = 'email';
    }
    else if(new RegExp('^[0-9]*$').test(this.userSearchFormControl.value!)){
      searchBy = 'id';
    }
  }
  //This is a temporary fix, as the rest of the app appears to be working without additional mapping.
  mapADUserList(adUsers: any)
  {
      let retVal: Array<IActiveDirectoryUserResponse> = [];
      adUsers.forEach((u: { displayName: any; aviationDirectoryUserID: any; email: any; firstName: any; isAviationDirectory: any; lastName: any; loginName: any;}) => {
        retVal.push({
          DisplayName: u.displayName,
          AviationDirectoryUserID: u.aviationDirectoryUserID,
          Email: u.email,
          FirstName: u.firstName,
          IsInAviationDirectory: u.isAviationDirectory,
          LastName: u.lastName,
          LoginName: u.loginName
        });
      });
      return retVal;
  }

  onCancelingAddUser(): void{
    this.dialogRef.close();
  }

  onNewUserSearch(): void{
    this.activeDirectoryUserList = [];
    this.userAlreadyExist = false;
    this.userHasBeenSelected = false;
    this.selectedUser = {
      DisplayName: '',
      FirstName: '',
      LastName: '',
      Email: '',
      LoginName: '',
      IsInAviationDirectory: false,
      AviationDirectoryUserID: 0}
    this.userSearchFormControl.reset();
  }

  onUserSelect(selectedUser: IActiveDirectoryUserResponse): void{
    this.userHasBeenSelected = true;
    this.selectedUser = selectedUser;
    if(selectedUser.IsInAviationDirectory){
      this.userAlreadyExist = true;
      return;
    }
    this.loading = true;
    this.utilService.getDivisionsList().subscribe(res =>{
      this.loading = false;
      if(res.messageType != 'OK'){
        return;
      }
      this.userDivisions = this.utilService.setDivisionList(res);
    });
  }

  onBackToUserList(): void{
    this.userHasBeenSelected = false;
    this.userAlreadyExist = false;
    this.onUserSearch();
  }

  onChangingDivision(selection: MatSelectChange): void{
    this.loading = true;
    this.utilService.getSectionsList(selection.value).subscribe(res =>{
      this.loading = false;
      if(res.messageType != 'OK'){
        return;
      }
      this.userSections= this.utilService.setSectionList(res);
    })
  }

  onNavigateToUserProfile(): void{
    if(this.selectedUser.IsInAviationDirectory && this.selectedUser.AviationDirectoryUserID != 0){
      this.router.navigate(['user-profile'], {queryParams: {userinfoid: this.selectedUser.AviationDirectoryUserID }})
      this.dialogRef.close();
    }
  }

  onAddingNewUser(): void{
    if(this.newUserInfoFormGroup.invalid){
      return;
    }
    this.loading = true;
    const newUser: INewUser = {
      firstName: this.selectedUser.FirstName,
      lastName: this.selectedUser.LastName,
      email: this.selectedUser.Email,
      loginName: 'ONE\\' + this.selectedUser.LoginName,
      divisionID: this.newUserInfoFormGroup.controls['divisionid'].value!,
      sectionID: this.newUserInfoFormGroup.controls['sectionid'].value!,
      jobTitle: this.newUserInfoFormGroup.controls['jobtitle'].value!,
      isAdmin: this.newUserInfoFormGroup.controls['admin'].value!,
      isSupervisor: this.newUserInfoFormGroup.controls['supervisor'].value!,
    }

    this.userService.addUserIntoAviationDirectory(newUser).subscribe(res =>{
      this.loading = false;
      if(new RegExp('^[0-9]*$').test(res)){
        this.userAddedSuccessfully = true;
        this.selectedUser.AviationDirectoryUserID = parseInt(res);
        this.selectedUser.IsInAviationDirectory = true;
      }
      else{
        this.userAddedSuccessfully = false;
      }
    })
  }

}
